const styles = {
  containerDesktop: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    backgroundColor: "primary.dark",
    alignItems: "center",
  },
  blackFade: {
    background: "linear-gradient( rgba(0, 0, 0, 0), #000 50%)",
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    px: 3,
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    maxWidth: 500,
    pt: 30,
    pb: 3,
    overflowY: "auto",
  },
  blackFadeDesktop: {},
  picture: { maxWidth: 500, mt: -10 },
  logo: {
    position: "absolute",
    top: 48,
    left: 32,
    width: 90,
  },
  text: {
    fontWeight: 400,
    fontSize: 18,
    mb: 1,
  },
  button: {
    borderRadius: 8,
    px: 3,
    py: 2,
    backgroundColor: "primary.main",
    textTransform: "none",
    fontSize: 20,
  },
  circle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    backgroundColor: "rgba(255, 255, 255, 0.1)",
    width: 30,
    height: 30,
    textAlign: "center",
    lineHeight: "30px",
    ml: 1,
    p: 1,
  },
};

export default styles;
